import { render, staticRenderFns } from "./FileActionItem.vue?vue&type=template&id=38a735d4&"
import script from "./FileActionItem.vue?vue&type=script&lang=js&"
export * from "./FileActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports